import moment from "moment";

import {
  //fetchDoctorAppointments,
  fetchMonitorTurns,
  fetchCupsCode,
} from "../../helpers/fetching";

const state = {
  buttonsAtention: [
    {
      id: "15456654222",
      Estado: "Volver a llamar",
    },
    {
      id: "189898488",
      Estado: "Ausente",
    },
    {
      id: "556574845",
      Estado: "No asistió",
    },
    {
      id: "7575757512",
      Estado: "Atendido",
    },
    {
      id: "00000000",
      Estado: 'Derivar'
    }
  ],
  buttonsAbsent: [
    {
      id: "4876545465458",
      Estado: "Llamar",
    },
    // {
    //   id: "748787899",
    //   Estado: "No asistió",
    // },
  ],
  headerTurns: [
    {
      name: "Estado",
      lastname: "",
    },
    {
      name: "Nombre",
      lastname: "",
    },
    {
      name: "Número",
      lastname: "ID",
    },
    {
      name: "Hora",
      lastname: "Llegada",
    },
    {
      name: "Hora",
      lastname: "Atendido",
    },
    {
      name: "Hora",
      lastname: "Finalizado",
    },
    {
      name: "Turno",
      lastname: "",
    },
  ],
  header: [
    {
      name: "Estado",
      lastname: "",
    },
    {
      name: "Nombre",
      lastname: "",
    },
    {
      name: "Número",
      lastname: "ID",
    },
    {
      name: "Hora",
      lastname: "Llegada",
    },
    {
      name: "Tiempo",
      lastname: "Espera / Atención",
    },
    {
      name: "Turno",
      lastname: "",
    },
    // {
    //   name: "Enviar SMS",
    //   lastname: "",
    // },
    // TODO: 1. uncomment me to enable SMS column
  ],
  body: [],
  appointments: [],
  turns: [],
  loadingTurns: false,
  loadingMainTurns: false,
  loadingDoctorPanelAppointments: false,
  services: [
  ],
  serviceDoctor: null,
  cupsCodes: [],
  loggedUserPanel: {},
};

const getters = {};

const actions = {
  fetchAppointmentsStaff({ dispatch, commit }, params) {
    //alert("AAAA")
    commit("setLoadingDoctorPanelAppointments", false);
    dispatch("changeThemeLoadingState", false);
    commit("setAppointments", []);

    console.log(params)
    // return new Promise((resolve) => {
    //   commit("setLoadingDoctorPanelAppointments", true);

    //   fetchDoctorAppointments(params)
    //     .then((response) => {
    //       let appointments = response.data;
    //       commit("setAppointments", appointments.response);
    //       setTimeout(() => {
    //         commit("setLoadingDoctorPanelAppointments", false);
    //         dispatch("changeThemeLoadingState", false);
    //       }, 3000);
    //       resolve();
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //       commit("setErrorStaffAppointment", error);
    //       commit("setLoadingDoctorPanelAppointments", false);
    //       dispatch("changeThemeLoadingState", false);
    //     });
    // });
  },

  getMonitorTurns({ commit, state }, params) {
    if (state.loadingTurns) return;
    return new Promise((resolve) => {
      commit("setLoadingDoctorPanel", true);

      fetchMonitorTurns(params)
        .then(async (response) => {
          
          let turns = response.data;
          console.log("ORIGINAL TURNS DATA", turns)
          // filter date
          turns = turns.filter(
            (t) =>
              moment(t.init_time_stamp).format("YYYY-MM-DD") >=
              moment().format("YYYY-MM-DD")
          );

          // Join witn appointments
          let appointments = state.appointments;
          console.log("STATE APPOINTMENTS", appointments)

          // filter by profile
          let callableQueueGroups =
            state.loggedUserPanel?.worker?.workerProfile?.callableQueueGroups;


            console.log("CALLABE GROUPS", callableQueueGroups)

          if (callableQueueGroups) {
            callableQueueGroups = callableQueueGroups
              .map((c) => c.queues)
              .map((c) => c[0].id);
            turns = turns.filter((t) =>
              callableQueueGroups.includes(t.queue_id)
            );
          } else {
            turns = [];
          }

          // restrinctions filter
          if (params.silver) {
            turns = turns.filter(
              (t) =>
                !params.silver.panelDoctor?.restrinctions?.includes(
                  t.queue_name.split("-")[1]?.toLowerCase()
                ) &&
                !params.silver.panelDoctor?.restrinctions?.includes(
                  t.derivation_queue_name?.split("-")[1]?.toLowerCase()
                )
            );
          }

          let count = 0;
          let appoints = [];
          let full_appointments = [];

          if (appointments.length > 0) {
            full_appointments = await new Promise((resolve) => {
              checkExist(
                resolve,
                appointments,
                count,
                turns,
                appoints,
                state.body
              );
            });
          }

          // Sanitize turns
          turns = turns.map((t) => {
            return {
              id: t.id,
              Estado:
                t.action_text == "INGRESO EXTERNO" ||
                t.action_text == "DERIVACION"
                  ? "Llamar"
                  : t.action_text == "FINALIZACION"
                  ? "Atendido"
                  : t.action_text == "CANCELADO EXTERNO" ||
                    t.action_text == "NO PRESENTA POR REINICIO" ||
                    t.action_text == "NO PRESENTA"
                  ? "No asistió"
                  : t.action_text == "LLAMADA" ||
                    t.action_text == "FINALIZACION POR REINICIO"
                  ? "Llamado"
                  : t.action_text == "LLAMADA MANUAL" ||
                    t.action_text == "RE LLAMADA"
                  ? "En atención"
                  : "Ausente",
              HoraCitaGrilla: moment(
                t.init_time_stamp
              ).format("HH:mm"),
              HoraCita: full_appointments.filter(a=> parseInt(a.NumeroID) == parseInt(t.turn_dni)).length > 0 ? moment(
                t.init_time_stamp
              ).format("hh:mm a") : 'SIN CITA',
              Nombre: t.turn_person?.replace('Undefined', '') || 'N/R',
              NumeroID: t.turn_dni,
              NumeroType: "",
              HoraLlegada: t.init_time_stamp
                ? moment(t.init_time_stamp).format("hh:mm a")
                : "",
              HoraAtendido: t.call_time_stamp
                ? moment(t.call_time_stamp).format("hh:mm a")
                : "",
              HoraFinalizado: t.finish_time
                ? moment(t.finish_time).format("hh:mm a")
                : "",
              NumberSMS: "",
              Autorizado: "",
              Pagado: "",
              Servicio: full_appointments.filter(a=> parseInt(a.NumeroID) == parseInt(t.turn_dni)),
              Atencion: "",
              showDropdown: state.turns.find((b) => b.id == t.id)?.showDropdown,
              Turno: {
                turn_id: t.id,
                caller_group_id: t.caller_group_id,
                waiting_room_id: t.waiting_room_id,
                queue_id: t.queue_id,
                code: t.code,
                number: t.number,
                letter: t.letter,
                user_call: t.user_email
              },
              Asesor: t.user_origin,
              Usuario: {
                turn_text: t.turn_text,
                turn_person: t.turn_person,
                turn_dni: t.turn_dni,
                turn_phone: t.turn_phone,
              },
              ExtraFields: t.extra_fields
            };
          });

          turns = turns.filter((t) => {
            let extrafields = t.extra_fields;
            try {
              extrafields = JSON.parse(extrafields);
              extrafields = extrafields[0];
            } catch (error) {
              extrafields = {};
            }

            if (!extrafields.appointment) return t;
          });

          console.log("TURNSS SORTED", turns)

          commit("setTurns", turns);
          commit("setBody", full_appointments);
          commit("setTurnsAppointments", full_appointments);
          commit("setLoadingDoctorPanel", false);
          resolve();
        })
        .catch((error) => {
          console.error(error);
          commit("setError", error);
          commit("setLoadingDoctorPanel", false);
        });
    });
  },

  getCupsCode({ commit }, params) {
    return new Promise((resolve) => {
      commit("setLoadingDoctorPanel", true);
      fetchCupsCode(params)
        .then((response) => {
          let cups_code = response.data.response;
          commit(
            "setCupsCodes",
            cups_code.map((c) => c.cups_code.S)
          );
          commit("setLoadingDoctorPanel", false);
          resolve();
        })
        .catch((error) => {
          console.error(error);
          commit("setError", error);
          commit("setLoadingDoctorPanel", false);
          resolve();
        });
    });
  },

  clearAppointments({ commit }) {
    commit("clearError");
    commit("setLoadingDoctorPanel", false);
    commit("setAppointments", []);
    commit("setTurns", []);
  },

  onChangeBody({ commit }, bodyData) {
    commit("changeBody", bodyData);
  },

  onChangeTurns({ commit }, bodyData) {
    commit("setTurns", bodyData);
  },

  onChangeButtonsAtention({ commit }, battData) {
    commit("changeButtonsAtention", battData);
  },

  onChangeButtonsAbsent({ commit }, babseData) {
    commit("changeButtonsAbsent", babseData);
  },

  setDoctorService({ commit }, service) {
    commit("changeDoctorService", service);
  },

  setLoggedUserPanel({ commit }, data) {
    commit("changeLoggedUserPanel", data);
  },

  setLoadingMainTurns({ commit }, data) {
    commit("setLoadingturns", data);
  },

  setServices({ commit }, services){
    commit("changeServices", services);
  }
};

function checkExist(resolve, appointments, count, turns, result = [], body) {
  let appointment = appointments[count];

  if (appointment) {
    let appoint = {
      id: appointment.pac_num + "_" + appointment.number_form,
      Estado: "SIN TURNO",
      HoraCita: moment(
        appointment.date_appoinment + " " + appointment.hour_appoinment
      ).format("hh:mm a"),
      Nombre: appointment.full_name || 'N/R',
      NumeroID: appointment.doc,
      NumeroType: appointment.tdoc.detail,
      HoraCitaGrilla: appointment.hour_appoinment,
      Servicio: appointment.service,
      Atencion: appointment.attention,
      HoraLlegada: "",
      HoraAtendido: "",
      HoraFinalizado: "",
      NumberSMS: appointment.mobile,
      Autorizado: appointment.authorized_appoinment,
      Pagado: appointment.appoinment_paid,
      showDropdown: body.find(
        (b) => b.id == appointment.pac_num + "_" + appointment.number_form
      )?.showDropdown,
    };

    for (let index = 0; index < turns.length; index++) {
      let turn = turns[index];
      let extrafields = turns[index].extra_fields;
      try {
        extrafields = JSON.parse(extrafields);
        extrafields = extrafields[0];
      } catch (error) {
        extrafields = {};
      }

      if (
        turn.turn_dni == appointment.doc &&
        extrafields.appointment == appointment.number_form
      ) {
        // if(turn.turn_dni == appointment.doc){

        if (!turns[index].exist) {
          appoint = {
            id: appointment.pac_num + "_" + appointment.number_form,
            Estado:
              turn.action_text == "INGRESO EXTERNO" ||
              turn.action_text == "DERIVACION"
                ? "Llamar"
                : turn.action_text == "FINALIZACION"
                ? "Atendido"
                : turn.action_text == "CANCELADO EXTERNO" ||
                  turn.action_text == "NO PRESENTA POR REINICIO" ||
                  turn.action_text == "NO PRESENTA"
                ? "No asistió"
                : turn.action_text == "LLAMADA"
                ? "Llamado"
                : turn.action_text == "LLAMADA MANUAL" ||
                  turn.action_text == "RE LLAMADA"
                ? "En atención"
                : "Ausente",
            HoraCitaGrilla: appointment.hour_appoinment,
            HoraCita: moment(
              appointment.date_appoinment + " " + appointment.hour_appoinment
            ).format("hh:mm a"),
            Nombre: appointment.full_name || 'NR',
            NumeroID: turn.turn_dni,
            NumeroType: appointment.tdoc.detail,
            HoraLlegada: turn.init_time_stamp
              ? moment(turn.init_time_stamp).format("hh:mm a")
              : "",
            HoraAtendido: turn.call_time_stamp
              ? moment(turn.call_time_stamp).format("hh:mm a")
              : "",
            HoraFinalizado: turn.finish_time
              ? moment(turn.finish_time).format("hh:mm a")
              : "",
            NumberSMS: appointment.mobile,
            Autorizado: appointment.authorized_appoinment,
            Pagado: appointment.appoinment_paid,
            Servicio: appointment.service,
            Atencion: appointment.attention,
            showDropdown: body.find(
              (b) => b.id == appointment.pac_num + "_" + appointment.number_form
            )?.showDropdown,
            Turno: {
              turn_id: turn.id,
              caller_group_id: turn.caller_group_id,
              waiting_room_id: turn.waiting_room_id,
              queue_id: turn.queue_id,
              code: turn.code,
              number: turn.number,
              letter: turn.letter,
              user_call: turn.user_email
            },
            Asesor: turn.user_origin,
            Usuario: {
              turn_text: turn.turn_text,
              turn_person: turn.turn_person,
              turn_dni: turn.turn_dni,
              turn_phone: turn.turn_phone,
            },
            ExtraFields: turn.extra_fields
          };

          turns[index].exist = true;
        }

        // turns = turns.splice(index, 1);
      }
    }

    result.push(appoint);
  }

  count++;

  if (appointments.length == count) {
    resolve(result);
  } else {
    checkExist(resolve, appointments, count, turns, result, body);
  }
}

const mutations = {
  clearError(state) {
    state.error = null;
    state.errorStaffAppointment = null;
  },
  setAppointments(state, data) {
    state.appointments = data;
    state.error = null;
    state.errorStaffAppointment = null;
  },
  setTurns(state, data) {
    state.turns = data;
    state.error = null;
    state.errorStaffAppointment = null;
  },
  // appointments with turns
  setTurnsAppointments(state, data) {
    state.turnsAppointments = data;
    state.error = null;
    state.errorStaffAppointment = null;
  },
  setBody(state, data) {
    state.body = data;
    state.error = null;
    state.errorStaffAppointment = null;
  },
  setProfile(state, data) {
    state.profileData = data;
    state.loadingAppointments = false;
    state.error = null;
    state.errorStaffAppointment = null;
  },
  setSchedule(state, data) {
    state.schedule = data;
    state.loadingAppointments = false;
    state.error = null;
    state.errorStaffAppointment = null;
  },
  setLoadingDoctorPanel(state, data) {
    state.loadingTurns = data;
  },
  setLoadingturns(state, data) {
    state.loadingMainTurns = data;
  },
  setLoadingDoctorPanelAppointments(state, data) {
    state.loadingDoctorPanelAppointments = data;
  },
  setError(state, data) {
    state.error = data;
  },

  setErrorStaffAppointment(state, data) {
    state.errorStaffAppointment = data;
  },

  changeBody(state, data) {
    state.body = data;
  },

  changeButtonsAtention(state, data) {
    state.buttonsAtention = data;
  },

  changeButtonsAbsent(state, data) {
    state.buttonsAbsent = data;
  },

  changeDoctorService(state, service) {
    state.serviceDoctor = service;
  },

  setCupsCodes(state, codes) {
    state.cupsCodes = codes;
  },

  changeLoggedUserPanel(state, data) {
    state.loggedUserPanel = data;
  },

  changeServices(state, services) {
    state.services = services;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
